import { ActionHeader, StyledGridCol, StyledGridRow } from "@/common/styles";
import Button from "@/common/elements/Button";
import { useImperativeHandle, forwardRef, useEffect, useState } from "react";
import Modal from "@/common/elements/Modal";
import Table from "@/common/elements/Table";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import CommonDatePicker from "@/common/elements/DatePicker";
import Checkbox from "antd/es/checkbox/Checkbox";
import {
  debounce,
  getOptionsFromRefList,
  hasCheckSecurity,
  isNonEmptyVariable,
} from "@/util/common_function";
import { useSelector } from "react-redux";
import { Form } from "antd";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import { setBookings } from "@/slices/bookingsSlice";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";

const ScheduledBookingInformation = forwardRef(({ scheduledBookingRef, startingPoint }) => {
  const dispatch = useDispatch();
  // const { bookings, bookingsFieldsEnabled } = useSelector(
  //   (state) => state?.bookings
  // );
  const { bookings, bookingsFieldsEnabled, isScheduledBooking } = useSelector(
    (state) => state?.bookings
  );

  const [form] = Form.useForm();
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    console.log(isScheduledBooking);
    console.log("useEffect triggered - bookings:", bookings);
    if (bookings !== null) {  
      if (bookings?.arrestReports?.[0]) {
        setFormData({
          scheduledBooking: bookings?.arrestReports?.[0]?.scheduledBooking,
          scheduledReleaseDateTime: isNonEmptyVariable(
            bookings?.arrestReports?.[0]?.scheduledReleaseDate
          )
            ? dayjs(
              `${bookings.arrestReports[0].scheduledReleaseDate || ""} ${bookings.arrestReports[0].scheduledReleaseTime || ""
              }`
            )
            : null,
          housingAgency: bookings?.arrestReports?.[0]?.housingAgency
            ? bookings?.arrestReports?.[0]?.housingAgency
            : "",

          scheduledBookingCleared:
            bookings?.arrestReports?.[0]?.scheduledBookingCleared,
          scheduledBookingClearanceReasonId:
            bookings?.arrestReports?.[0]?.scheduledBookingClearanceReasonId,

          scheduledBookingClearanceDateTime: isNonEmptyVariable(
            bookings?.arrestReports?.[0]?.scheduledBookingClearanceDate
          )
            ? dayjs(
              `${bookings.arrestReports[0].scheduledBookingClearanceDate || ""
              } ${bookings.arrestReports[0].scheduledBookingClearanceTime || ""
              }`
            )
            : dayjs(),
        });
      }
      if(isScheduledBooking && !bookings?.arrestReports?.[0]?.scheduledBooking) {
        setFormData({
            scheduledBooking: true,
            // scheduledBookingCleared: true,
          });
      }
    } else {
      setFormData(null);
    }
  }, [bookings]);

  useEffect(() => {
    if (formData !== null) {
      form.setFieldsValue(formData);
    } else {
      form.resetFields();
    }
  }, [formData]);

  const scheduledBooking = Form.useWatch("scheduledBooking", form);
  const scheduledBookingCleared = Form.useWatch(
    "scheduledBookingCleared",
    form
  );

  useImperativeHandle(scheduledBookingRef, () => ({
    submitForm: () => form.submit(),
    resetForm: () => form.resetFields(),
    getFormValues: () => form.getFieldsValue(),
    getFieldsError: () => form.getFieldsError(),
    isFieldsValidating: () => form.isFieldsValidating(),
    validateFields: () => form.validateFields(),
  }));

  const updateForm = (data) => {
    console.log("data", data);

    // Update Redux state dynamically
    dispatch(
      setBookings({
        arrestReports: [
          {
            ...bookings?.arrestReports?.[0],
            ...data,
          },
        ],
      })
    );
  };

  const dataModify = debounce(() => {
    const values = form.getFieldsValue();

    values.housingAgency = values?.housingAgency || "";
    values.scheduledReleaseDateTime = values?.scheduledReleaseDateTime
      ? dayjs(values?.scheduledReleaseDateTime)?.format("MM/DD/YYYY HH:mm")
      : null;

    values.scheduledBookingClearanceDateTime =
      values?.scheduledBookingClearanceDateTime
        ? dayjs(values?.scheduledBookingClearanceDateTime)?.format(
          "MM/DD/YYYY HH:mm"
        )
        : null;

    const data = {
      ...values,
      scheduledReleaseDate: values?.scheduledReleaseDateTime?.split(" ")[0],
      scheduledReleaseTime: values?.scheduledReleaseDateTime?.split(" ")[1],
      scheduledBookingClearanceDate:
        values?.scheduledBookingClearanceDateTime?.split(" ")[0],
      scheduledBookingClearanceTime:
        values?.scheduledBookingClearanceDateTime?.split(" ")[1],
    };

    delete data?.scheduledBookingClearanceDateTime;
    delete data?.scheduledReleaseDateTime;

    console.log("First data", data);

    updateForm(data);
  }, 300);

  return (
    <>
      <Form
        form={form}
        initialValues={formData}
        disabled={!bookingsFieldsEnabled}
        onFieldsChange={() => {
          dataModify();
        }}
      >
        <StyledGridRow gutter={24}>
          <StyledGridCol lg={6}>
            <FormItem
              name="scheduledBooking"
              label="Scheduled Booking?"
              layout="horizontal"
              labelPostion={"label-right"}
              valuePropName="checked"
            >
              <Checkbox />
            </FormItem>
          </StyledGridCol>

          {scheduledBooking && (
            <>
              <StyledGridCol lg={10}>
                <FormItem
                  name="scheduledReleaseDateTime"
                  label="Scheduled Report Date And Time"
                  rules={[
                    {
                      required: true,
                      message:
                        "If this is a scheduled booking, you must enter the scheduled report date.",
                    },
                  ]}
                >
                  <CommonDatePicker
                    format="MM/DD/YYYY HH:mm"
                    placeholder="Select Date and Time"
                    disabled={!bookingsFieldsEnabled || !hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.MODIFY, "", "", "ArrestReports", "scheduledReleaseDateTime", startingPoint)}
                    className={hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.VIEW, "", "", "ArrestReports", "scheduledReleaseDateTime", startingPoint) ? "" : "input-control-mask"}
                  />
                </FormItem>
              </StyledGridCol>

              <StyledGridCol lg={6}>
                <FormItem
                  name="housingAgency"
                  label="Facility"
                  rules={[
                    {
                      required: true,
                      message:
                        "You must select the facility.",
                    },
                  ]}
                >
                  <Select
                    options={getOptionsFromRefList(
                      "Housing_Agency",
                      false,
                      false,
                      true
                    )}
                    placeholder="Facility"
                    showSearch={false}
                    variant="outlined"
                    disabled={!bookingsFieldsEnabled || !hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.MODIFY, "", "", "ArrestReports", "housingAgency", startingPoint)}
                    className={hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.VIEW, "", "", "ArrestReports", "housingAgency", startingPoint) ? "" : "input-control-mask"}
                  />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol xs={24}>
                <StyledGridRow gutter={24}>
                  <StyledGridCol lg={6}>
                    <FormItem
                      name="scheduledBookingCleared"
                      label="cleared?"
                      layout="horizontal"
                      labelPostion={"label-right"}
                      valuePropName="checked"
                    >
                      <Checkbox 
                      className={hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.VIEW, "", "", "ArrestReports", "scheduledBookingCleared", startingPoint) ? "" : "input-control-mask"} />
                    </FormItem>
                  </StyledGridCol>
                  {scheduledBookingCleared && (
                    <>
                      <StyledGridCol lg={6}>
                        <FormItem
                          name="scheduledBookingClearanceReasonId"
                          label="Clearance Reason"
                          rules={[
                            {
                              required: true,
                              message:
                                "If this scheduled booking has been cleared, you must enter the reason.",
                            },
                          ]}
                        >
                          <Select
                            id="clearanceReason"
                            options={getOptionsFromRefList(
                              "Scheduled_Booking_Clearance_Reason",
                              false,
                              false,
                              true
                            )}
                            placeholder="Clearance Reason"
                            showSearch={false}
                            variant="outlined"
                            disabled={!bookingsFieldsEnabled || !hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.MODIFY, "", "", "ArrestReports", "scheduledBookingClearanceReasonId", startingPoint)}
                            className={hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.VIEW, "", "", "ArrestReports", "scheduledBookingClearanceReasonId", startingPoint) ? "" : "input-control-mask"} 
                          />
                        </FormItem>
                      </StyledGridCol>

                      <StyledGridCol lg={10}>
                        <FormItem
                          name="scheduledBookingClearanceDateTime"
                          label="Clearance Date/Time"
                          initialValue={dayjs()}
                        >
                          <CommonDatePicker
                            format="MM/DD/YYYY HH:mm"
                            placeholder="Select Date and Time"
                            value={
                              form.getFieldValue(
                                "scheduledBookingClearanceDateTime"
                              ) || dayjs()
                            }
                            onChange={(date) =>
                              form.setFieldsValue({
                                scheduledBookingClearanceDateTime: date,
                              })
                            }
                            disabled={!bookingsFieldsEnabled || !hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.MODIFY, "", "", "ArrestReports", "scheduledBookingClearanceDateTime", startingPoint)}
                            className={hasCheckSecurity(Security_Types.functionality, Entity_types.field, LABELS_CAPITAL.VIEW, "", "", "ArrestReports", "scheduledBookingClearanceDateTime", startingPoint) ? "" : "input-control-mask"} 
                          />
                        </FormItem>
                      </StyledGridCol>
                    </>
                  )}
                </StyledGridRow>
              </StyledGridCol>
            </>
          )}
        </StyledGridRow>
      </Form>
    </>
  );
});
export default ScheduledBookingInformation;
